<div class="container">
  <div *ngIf="scheduleResponse && scheduleResponse.childList && scheduleResponse.childList.length > 0; else emptyList">

    <table #notificationTable data-testid="notificationTable" class="detail-tab notificationTable">
      <thead>
        <tr>
          <th class="pl-4" style="text-align: center;">{{ 'notification.id' | translate }}</th>
          <th style="text-align: center;">{{ 'notification.touchPointName' | translate }}</th>
          <th style="text-align: center;">{{ 'notification.staticListName' | translate }}</th>
          <th style="text-align: center;">{{ 'notification.airshipScheduleId' | translate }}</th>
          <th style="text-align: center;">{{ 'notification.status' | translate }}</th>
          <th style="text-align: center;">{{ 'notification.error' | translate }}</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let touchpoint of scheduleResponse.childList; let i = index;">
          <td class="pl-4" style="text-align: center;">{{ touchpoint.id }}</td>
          <td style="text-align: center;">{{ touchpoint.touchPointName }}</td>
          <td style="text-align: center;">{{ touchpoint.staticListName }}</td>
          <td style="text-align: center;">{{ touchpoint.airshipScheduleId }}</td>
          <td style="text-align: center;">
            <span class="status-badge"
              [ngClass]="{
                'status-green':   getStatusColor(touchpoint.status) === StatusColor.GREEN,
                'status-orange':  getStatusColor(touchpoint.status) === StatusColor.ORANGE,
                'status-red':     getStatusColor(touchpoint.status) === StatusColor.RED,
                'status-unknown': getStatusColor(touchpoint.status) === StatusColor.UNKNOWN
              }">
              {{ 'scheduleStatus.' + touchpoint.status | translate }}
            </span>
          </td>
          <td style="text-align: center;">
            <span *ngIf="touchpoint.error; else noError" class="status-badge status-red">
              {{ touchpoint.error.code }} - {{ touchpoint.error.message }}
            </span>
            <ng-template #noError>
              <span>-</span>
            </ng-template>
          </td>
       <!--    <td>
            <div class="detail-btn-container">
              <div class="d-flex flex-row">
                <button
                  data-testid-generic="notification-details"
                  [attr.data-testid]="'notification-details-' + touchpoint.id"
                  class="btn-details"
                  (click)="toggleMenu(touchpoint.id, i)">
                  <i class="pi pi-ellipsis-h margin-fit"></i>
                </button>
                <div class="dropdown-menu" *ngIf="touchpoint.menuActivated == true">
                  <button
                    class="dropdown-item-creation"
                    data-testid-generic="notification-delete"
                    [attr.data-testid]="'notification-delete-' + touchpoint.id"
                    (click)="onDeleteNotification(touchpoint, i)"
                    [disabled]="touchpoint.status === 'DELETED'"
                    [ngClass]="{'disabled-button': touchpoint.status === 'DELETED'}">
                    {{ 'notification.delete_notification' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>

</div>

<ng-template #emptyList>
  <div class="empty-list-container d-flex justify-content-center">
    <span class="empty-list-message" style="padding: 20px;">{{ 'notification.no_notification_available' | translate }}</span>
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-detail/notification-details.component.html